import { FC } from 'react';

import { isValidReactChild } from 'utils/type-guards';

import styles from './DescriptionList.module.scss';

interface Props {
  children: React.ReactNode;
}

const DescriptionList: FC<Props> = ({ children }) => (
  <dl className={styles.container}>
    {Array.isArray(children)
      ? // eslint-disable-next-line react/no-array-index-key
        children.filter(isValidReactChild).map((child) => <div key={child.key}>{child}</div>)
      : children}
  </dl>
);

export type { Props as DescriptionListProps };
export default DescriptionList;
